namespace $ {
	export class $shm_hitalama_map_transfer_table extends $mol_object {
		
		@ $mol_action
		static serialize( table: $shm_hitalama_map_widget_entity_table ) {
			return {
				ref: table.link().toString(),

				head: table.Head()?.val(),
				head_method: table.Head_method()?.val(),
				rows: table.Rows()?.val(),
				rows_method: table.Rows_method()?.val(),
				rows_limit: table.Rows_limit()?.val(),
				col_widths: table.Col_widths()?.val(),
				col_types: table.Col_types()?.val(),
				cols_hidden: table.Cols_hidden()?.val(),
				cols_order: table.Cols_order()?.val(),
				cols_pinned: table.Cols_pinned()?.val(),
				rows_checked: table.Rows_checked()?.val(),
			}
		}

		@ $mol_action
		static deserialize( table: $shm_hitalama_map_widget_entity_table, dto: ReturnType< typeof $shm_hitalama_map_transfer_table['serialize'] > ) {
			table.Head( dto.head )?.val( dto.head )
			table.Head_method( dto.head_method )?.val( dto.head_method?.replaceAll('board','map') )
			table.Rows( dto.rows )?.val( dto.rows )
			table.Rows_method( dto.rows_method )?.val( dto.rows_method?.replaceAll('board','map') )
			table.Rows_limit( dto.rows_limit )?.val( dto.rows_limit )
			table.Col_widths( dto.col_widths )?.val( dto.col_widths )
			table.Col_types( dto.col_types )?.val( dto.col_types )
			table.Cols_hidden( dto.cols_hidden )?.val( dto.cols_hidden )
			table.Cols_order( dto.cols_order )?.val( dto.cols_order )
			table.Cols_pinned( dto.cols_pinned )?.val( dto.cols_pinned )
			table.Rows_checked( dto.rows_checked )?.val( dto.rows_checked )
		}
		
	}
}
